// @flow
import React, { useState, useCallback } from 'react';

import { navigate } from '../../lib/helpers';
import { budgetsForAnalysisApi } from '../../lib/api';
import { type BudgetsForAnalysis } from '../../lib/types';

import CommonCardPage from '../../components/hoc/common/handbook/CardPage';
import { InnerForm } from './components';
import { getBreadCrumbsByUrlForEdit } from '../../lib/autoBreadcrumbs';

type PageProps = {
  id: number
};

const entryPointPath = '/admin/budgets-for-analysis/';

export default (props: PageProps) => {
  const [data: BudgetsForAnalysis, setData] = useState({
    id: props.id
  });

  const breadCrumbs = getBreadCrumbsByUrlForEdit(entryPointPath, props.id);

  const onFetch = useCallback(async () => {
    !!props.id && setData(await budgetsForAnalysisApi.get(props.id));
  }, [props.id]);

  const onSubmit = async (payload: BudgetsForAnalysis) => {
    let id = payload.id;
    if (id) {
      await budgetsForAnalysisApi.update(payload);
    } else {
      let data = await budgetsForAnalysisApi.add(payload);
      id = data.id;
    }
    await navigate(`${entryPointPath}${id}`);
  };

  const onCancel = async (payload: BudgetsForAnalysis) => {
    if (data.id) {
      await navigate(`${entryPointPath}${data.id}`);
    } else await navigate(`${entryPointPath}`, true);
  };

  return (
    <CommonCardPage
      pageHeaderProps={{
        breadCrumbs,
        mainHeader: 'Бюджеты для анализа'
      }}
      onFetch={onFetch}
      onSubmit={onSubmit}
      onCancel={onCancel}
    >
      <InnerForm data={data} useFooter noWrapMe />
    </CommonCardPage>
  );
};
